<div class="trustpilot-page">
  <div class="title">
    <p class="vox-heading-2" translate>sales.trustpilot.title</p>
  </div>
  <hr />
  <div class="form-container">
    <form [formGroup]="form" (ngSubmit)="sendRequest()">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <label for="first-name" translate>sales.trustpilot.form.first-name.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{
            'vox-input-group_invalid': name.dirty && name.invalid,
            'vox-input-group_valid': name.dirty && name.valid
            }
            ">
            <input class="vox-text-field"
              type="text"
              id="name"
              placeholder="{{ 'sales.trustpilot.form.first-name.placeholder' | translate }}"
              formControlName="name" />
            <i *ngIf="name.invalid" class="vox-text-field__icon  icon-small-alert"></i>
            <i *ngIf="name.valid" class="vox-text-field__icon  icon-small-check"></i>
            <span class="vox-input-group__error-message" translate>sales.trustpilot.form.error</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <label for="email" translate>sales.trustpilot.form.email.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{
            'vox-input-group_invalid': email.dirty && email.invalid,
            'vox-input-group_valid': email.dirty && email.valid
            }">
            <input class="vox-text-field"
              type="email"
              id="email"
              placeholder="{{ 'sales.trustpilot.form.email.placeholder' | translate }}"
              formControlName="email"/>
            <i *ngIf="email.invalid" class="vox-text-field__icon  icon-small-alert"></i>
            <i *ngIf="email.valid" class="vox-text-field__icon  icon-small-check"></i>
            <span class="vox-input-group__error-message" translate>sales.trustpilot.form.error</span>
          </div>
        </div>
      </div>
      <div class="submit-container">
        <button class="vox-btn vox-btn-primary"
          type="submit"
          [disabled]="form.invalid"
          [ladda]="loading">
          {{'sales.trustpilot.form.button' | translate}}
        </button>
      </div>
    </form>
  </div>
</div>
